const loadMore = document.querySelector("#cart-drawer");

const affirmObserver2 = new MutationObserver(function(mutations) {

  let checkoutButton = document.querySelector('button[name="checkout"]');
  let currentPrice = document.querySelector(".cart-drawer__button-price")?.outerHTML.replace(/\D/g, "");
  
  if (currentPrice && !checkoutButton.nextSibling) {
    
    let html = `<p class='affirm-as-low-as' data-page-type='product' data-amount=${currentPrice}></p>`;
    checkoutButton.insertAdjacentHTML("afterend", html);
    affirm?.ui?.ready(function() {
      affirm?.ui?.refresh();
    });
    
  }

}); 

affirmObserver2.observe(loadMore, { childList: true, subtree: true, attributes: true });